<!-- Paging template -->
<template>
    <div v-bind:id="id" class="loader-div" v-bind:title="message"><img src="../assets/error.png" width="24" alt=""></div>
</template>
<script>
// v-bind:title="message"

export default {
  name: 'ErrorPopper',
  props: {
    show: Boolean,
    message: String
  },
  data: function () {
    return {
      id: null
    };
  },
  mounted () {
    this.id = this._uid;
  },
  methods: {

  },
  watch: {
    message: function () {
      $('[data-toggle="tooltip"]').tooltip();
    }
  }
};

</script>

<style lang="scss">
    .loader-div {
        color: #999;
    }
</style>
